module.exports = __webpack_public_path__ + "assets/static/png/ico-3d-secur.89ae30b61f5ee19cc1fcc55ca7e2d63f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/ico-3d-secur.png
 ** module id = 491
 ** module chunks = 1
 **/